import {
	GET_ALL_USERS_START,
	GET_ALL_USERS_SUCCESS,
	GET_ALL_USERS_FAILED,
	GET_DOMAIN_USERS_START,
	GET_DOMAIN_USERS_SUCCESS,
	GET_DOMAIN_USERS_FAILED,
	GET_RECENTLY_VIEWED_DATA_START,
	GET_RECENTLY_VIEWED_DATA_SUCCESS,
	GET_RECENTLY_VIEWED_DATA_FAILED,
	GET_RECENT_KEYWORDS_START,
	GET_RECENT_KEYWORDS_SUCCESS,
	GET_RECENT_KEYWORDS_FAILED,
	GET_CALLER_USERS_START,
	GET_CALLER_USERS_SUCCESS,
	GET_CALLER_USERS_FAILED,
	// DELETE_USER_FROM_USER_MANAGEMENT_START,
	// DELETE_USER_FROM_USER_MANAGEMENT_SUCCESS,
	// DELETE_USER_FROM_USER_MANAGEMENT_FAILED,
	// DELETE_DOMAIN_FROM_USER_ROLE_START,
	// DELETE_DOMAIN_FROM_USER_ROLE_SUCCESS,
	// DELETE_DOMAIN_FROM_USER_ROLE_FAILED
} from '../actionTypes/user'

export const initialState = {
	isLoading: false,
	users: [],
	domainUsers: [],
	recentlyVieweSearchdData: [],
	recentKeywords: [],
	callerUsers: [],
}

const user = (state = initialState, action) => {
	switch (action.type) {
		case GET_ALL_USERS_START:
			return {
				...state,
				isLoading: true,
			};
		case GET_ALL_USERS_SUCCESS:
			return {
				...state,
				isLoading: false,
				users: action.data
			};
		case GET_ALL_USERS_FAILED:
			return {
				...state,
				isLoading: false,
			};
		case GET_DOMAIN_USERS_START:
			return {
				...state,
				isLoading: true,
			};
		case GET_DOMAIN_USERS_SUCCESS:
			return {
				...state,
				isLoading: false,
				domainUsers: action.data
			};
		case GET_DOMAIN_USERS_FAILED:
			return {
				...state,
				isLoading: false,
			};
		case GET_RECENTLY_VIEWED_DATA_START:
			return {
				...state
			};
		case GET_RECENTLY_VIEWED_DATA_SUCCESS:
			return {
				...state,
				recentlyVieweSearchdData: action.data
			};
		case GET_RECENTLY_VIEWED_DATA_FAILED:
			return {
				...state
			};
		case GET_RECENT_KEYWORDS_START:
			return {
				...state
			};
		case GET_RECENT_KEYWORDS_SUCCESS:
			return {
				...state,
				recentKeywords: action.data
			};
		case GET_RECENT_KEYWORDS_FAILED:
			return {
				...state
			};
		case GET_CALLER_USERS_START:
			return {
				...state,
				isLoading: false,

			};
		case GET_CALLER_USERS_SUCCESS:
			return {
				...state,
				callerUsers: action.data
			};
		case GET_CALLER_USERS_FAILED:
			return {
				...state,
			};
		// case DELETE_USER_FROM_USER_MANAGEMENT_START: 
		// 	console.log("reducer start")
		// 	return {
		// 		...state,
		// 		isLoading: true
		// 	};
		// case DELETE_USER_FROM_USER_MANAGEMENT_SUCCESS: 
		// 	return {
		// 		...state,
		// 		isLoading: false,
		// 	}
		// case DELETE_USER_FROM_USER_MANAGEMENT_FAILED: 
		// 	return {
		// 		...state
		// 	};
		// case DELETE_DOMAIN_FROM_USER_ROLE_START: 
		// 	return {
		// 		...state,
		// 		isLoading: true
		// 	};
		// case DELETE_DOMAIN_FROM_USER_ROLE_START: 
		// 	return {
		// 		...state,
		// 		isLoading: false
		// 	};
		// case DELETE_DOMAIN_FROM_USER_ROLE_START: 
		// 	return {
		// 		...state,
		// 	};

		default:
			return state;
	}
}

export default user